import React, { Component } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import {
  Radio,
  Button,
  Paper,
  FormControl,
  CircularProgress,
  Dialog,
  Fade,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import * as actions from "../../actions";
import { connect } from "react-redux";
import moment from "moment";
import { withTheme } from "@material-ui/core/styles";
import {
  getOffSetTime,
  SERVER_URL,
  formatCreditCardNumber,
  formatExpirationDate,
  formatCVC,
} from "../../utils/config/constants.js";
import AddressPanel from "../../components/Booking/AddressPanel.jsx";
import { TextField } from "@material-ui/core";
import DateTimePanel from "../../components/Booking/DateTimePanel";
import ConfirmedData from "../../components/Booking/ConfirmedData.jsx";
import PromocodePanel from "../../components/Booking/PromocodePanel.jsx";
import BookingTimeSlotPopup from "../../components/Booking/BookingTimeSlotPopup.jsx";
import AddPromoPopup from "../../components/Booking/AddPromoPopup.jsx";
import { NotificationManager } from "react-notifications";
import AddAddressPopup from "../../components/Booking/AddAddressPopup";
import { FormattedMessage, injectIntl } from "react-intl";
import AddWalletMoney from "../../components/Customer/AddWalletMoney";
import withUser from "../../components/HOC/HOCwithUser.jsx";
import withCustomTheme from "../../components/HOC/HOCwithCustomTheme.jsx";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dropzone from "react-dropzone";
import ReactCrop from "react-image-crop";
import Datetime from "react-datetime";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import axios from "axios";
import { getCookies } from "../../utils/getToken";
import { Delete, HighlightOff } from "@material-ui/icons";
import HOCSectionLoader from "../../components/HOC/HOCSectionLoader";
import SavedCards from "../../components/Booking/SavedCards";
import AddNewCard from "../../components/Booking/AddNewCard";
import DeleteAlert from "../../components/Alert/DeleteAlert";
import { validateCreditCardForm } from "../../utils/validators/validateForm";
import Card from "react-credit-cards";
import { Clear, Add, Remove, GpsFixed, LocationOn } from '@material-ui/icons';

const handleDropRejected = (...args) =>
  NotificationManager.error(
    <FormattedMessage
      id="errorUploading"
      defaultMessage="Unable to upload this picture, try another"
    />,
    "Error"
  );
class Create extends Component {
  constructor(props) {
    super();
    const commonStates = {
      businessHoursOpen: false,
      bookingPopup: false,
      loginPopup: false,
      bookingData: [],
      dateTimeValue: "",
      slots: [],
      haveSlots: false,
      addCoupon: false,
      timeSlot: "",
      bookingTimeSlot: "",
      todayBookinTimeSlot: "",
      isTodaySlot: false,
      addAddress: false,
      isPromoApplied: false,
      promocode: "",
      notes: "",
      finalAmount: "",
      paymentType: 1,
      card_no_four_digit: "",
      displayAddress:
        props.userData.addresses.length > 0
          ? props.userData.addresses.filter(
            (address) => address.is_default == 1
          )[0]
          : "",
      packageItem: null,
      showFundOption: false,
      showAddWalletOption: false,
      showAddPopup: false,
      openDateTime: false,
      bookingValue: "",
      serviceTypeValue: "onetime",
      atHomeValue: "yes",
      showRecurringType: false,
      files: [],
      preview: null,
      crop: {
        aspect: 1 / 1,
      },
      croppedImageUrl: "",
      additionalTextValue: "",
      showAdditionalText: false,
      atHomeStatus: true,
      forFuture: null,
      uploadedImages: [],
      imageNameDataSource: [],
      packageServiceData: [],
      createLoader: true,
      removeIndex: null,
      removingImage: false,
      service_type_id: 0,
      showServiceType: true,
      recurring_type_id: 0,
      isTodayProcessing: false,
      showPaymentModal: false,
      number: "",
      name: "",
      expiry: "",
      cvc: "",
      issuer: "",
      focused: "",
      formData: null,
      bookingId: "",
      cardPayAmount: "0",
      booking: "",
      redirectBookingSuccess: false,
      loaderButton: false,
      deleteAlert: false,
      cardSelected: "",
      acceptLoadingButton: false,
      isPayClick: "",
      card_payment_detail: [],
      rejected_services: [],
      hourly_booked_services: [],
      package_booked_services: [],
      fromBookingDetail: false,
      redirectBookingStatus: false,
      cardList: [],
      serviceDetailData: [],
    };

    this.handleDrop = this.handleDrop.bind(this);

    if (props.match.params) {
      this.state = {
        providerId: props.match.params.providerId,
        serviceId: props.match.params.serviceId,
        loader: true,
        itemId: props.match.params.itemId,
        ...commonStates,
      };
    } else {
      this.state = {
        providerId: "",
        serviceId: "",
        loader: true,
        itemId: "",
        ...commonStates,
      };
    }
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.userData.addresses.length !==
      this.props.userData.addresses.length
    ) {
      this.setState({
        displayAddress: this.props.userData.addresses.filter(
          (address) => address.is_default === 1
        )[0],
        packageItem: this.state.bookingData.packages
          ? this.state.bookingData.packages.filter(
            (pack) => pack.key === this.state.itemId
          )[0]
          : [],
      });
    }
  }
  componentDidMount() {
    this.props.savedCardListAction(this.onCardListReceived);
    this.preBookingDetail();
    console.log("UserData props:::::::for address::::::", this.props.userData);
    this.getData();
    this.props.promoCodeListAction();
  }

  onCardListReceived = (success, data) => {
    console.log("Card Seved List:::", data.data.sources);
    if (success && data.data.sources.data != []) {
      this.setState({
        cardSelected: data.data.sources.data[0],
        cardList: data.data.sources.data,
      });
    }
  };

  preBookingDetail = () => {
    console.log("111111111111111111111111111111111111111111111111111111111", this.props.location.state.serviceDataSource)

    var authToken = getCookies();
    axios({
      method: "post",
      url: `${SERVER_URL}/booking/prebooking`,
      data: {
        services: this.props.location
          ? this.props.location.state.serviceDataSource
          : [{}],
      },
      headers: { "x-auth-token": authToken },
    }).then((resJson) => {

      if (resJson.data.status == "OK") {
        var once = 0;
        var recurring = 0;
        var both = 0;
        resJson.data.data.services.map((serviceItem) => {
          if (serviceItem.booking_type == "once") {
            once += 1;
          } else if (serviceItem.booking_type == "recur") {
            recurring = recurring + 1;
          } else if (serviceItem.booking_type == "both") {
            both = both + 1;
          }
        });

        console.log(
          "count once",
          once,
          " count recur ",
          recurring,
          " count both",
          both
        );
        console.log("PreBooking Dataaaaa:::", resJson.data.data);
        console.log("UUUUUUUUUUUUUUUUUU<<<<<<<mmmmmmmmmmm", resJson.data.data.last_payment_method)
        this.setState(
          {
            packageServiceData: resJson.data.data.package_services,
            createLoader: false,
            paymentType: resJson.data.data.last_payment_method,
            service_type_id: recurring > 0 ? 1 : 0,
            showServiceType: recurring > 0 ? false : both > 0 ? true : false,
            showRecurringType: recurring > 0 ? true : false,
            serviceDetailData: resJson.data,
          },
          () => {
            console.log("sskkdksd:::::::::", this.state.packageServiceData);
          }
        );
        console.log("UUUUUUUUUUUUUUUUUUPPPPPPPPPPPPPPPP", this.state.paymentType)
      } else {
        NotificationManager.error("Oops!", resJson.data.message),
          this.setState({
            createLoader: false,
          });
      }
    });
  };
  getData = () => {
    this.props.providerDetailAction(
      {
        providerId: this.state.providerId,
        serviceId: this.state.serviceId,
        day: new Date().getDay(),
      },
      this.onDone
    );
  };
  onDone = (success, data) => {
    if (success) {
      this.setState({
        bookingData: data,
        loader: false,
        packageItem: data.packages.filter(
          (pack) => pack.key === this.state.itemId
        )[0],
      });
    } else {
      this.setState({ loader: false, error: data });
    }
  };

  onChangeDate = (event) => {
    console.log("date event::::::::", event);
    const dateTimeValue = moment(event).format("Y-MM-DD");
    this.setState({
      openDateTime: true,
      dateTimeValue: dateTimeValue,
      isTodaySlot: false,
    });
    this.getSlots(dateTimeValue);
  };

  getSlots = (chosenDate) => {
    console.log("chooosen date::::::::::::::::", chosenDate);
    this.props.bookingTimeSlotAction(
      {
        providerId: this.state.providerId,
        day: new Date(chosenDate).getDay(),
        date: chosenDate,
        offset: new Date().getTimezoneOffset(),
        currentDate: new Date(),
      },
      this.onDateTimeSelected
    );
  };
  onDateTimeSelected = (success, data) => {
    if (success) {
      this.setState({
        slots: data.data.slots,
        haveSlots: true,
        openDateTime: false,
      });
    } else {
      NotificationManager.error(
        <FormattedMessage
          id="noSlotsAvailable"
          defaultMessage="Sorry No Slots Available"
        />,
        "Error"
      );
    }
  };
  closeTimeSlotPopup = () => {
    this.setState({
      haveSlots: false,
      bookingValue: this.state.forFuture ? "future" : "today",
      isTodayProcessing: false,
    });
  };
  closeCouponPopup = () => {
    this.setState({ addCoupon: false });
  };

  closeAddressPopup = () => {
    this.setState({ addAddress: false });
  };

  renderPromoPopup = () => {
    this.setState({ addCoupon: true });
  };
  addNewAddress = () => {
    this.setState({ addAddress: true });
  };

  appliedPromo = (code, discountedAmount) => {
    this.setState({
      isPromoApplied: true,
      promocode: code,
      finalAmount: discountedAmount,
    });
  };
  setAddress = (address) => {
    console.log("Display Address ::::", address);

    this.setState({ displayAddress: address });
  };
  setTimeSlot = (slot, isTodaySlot) => {
    const timeValue = getOffSetTime(slot.start);
    if (isTodaySlot) {
      this.setState({
        timeSlot: timeValue,
        todayBookinTimeSlot: slot,
        bookingTimeSlot: "",
        isTodayProcessing: false,
      });
    } else {
      this.setState({
        timeSlot: timeValue,
        bookingTimeSlot: slot,
        todayBookinTimeSlot: "",
      });
    }
  };
  handlePaymentOption = (event) => {
    console.log("UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUPayment Type:::::", event.target.value);
    this.setState({ paymentType: event.target.value });
  };

  closePaymentModal = () => {
    this.setState({
      showPaymentModal: false,
    });
  };

  checkDeleteCard = () => {
    console.log("rj check delete card")
    this.props.savedCardListAction(this.onCardListReceived);

  };

  renderButton = () => {
    if (this.state.loaderButton) {
      return <CircularProgress />;
    } else {
      return (
        <button className="btn btn-primary btn-block" onClick={this.addNewCard}>
          <FormattedMessage id="payment.add" defaultMessage="Add" />
        </button>
      );
    }
  };
  addNewCard = () => {
    if (
      validateCreditCardForm(
        {
          number: this.state.number,
          name: this.state.name,
          expiry: this.state.expiry,
          cvc: this.state.cvc,
        },
        this.handleError
      )
    ) {
      this.setState({ loaderButton: true });
      this.props.cardAddAction(
        {
          number: this.state.number,
          name: this.state.name,
          expiry: this.state.expiry,
          cvc: this.state.cvc,
        },
        this.onDoneAdding
      );
    } else {
      NotificationManager.error(
        <FormattedMessage
          id="addCorrectDetails"
          defaultMessage="Please add correct details in payment form"
        />,
        "Error"
      );
    }
  };
  redirectList = () => {
    this.getData();
  };

  handleError = (params) => {
    this.setState(params);
  };

  onDoneAdding = (success, data) => {
    this.setState({ loaderButton: false });
    if (success) {
      NotificationManager.success(
        <FormattedMessage
          id="cardAddedSuccess"
          defaultMessage="Card added successfully"
        />,
        "Success"
      );
    } else {
      NotificationManager.error(data.message, "Error");
    }
  };

  handleCallback = ({ issuer }, isValid) => {
    if (isValid) {
      this.setState({ issuer });
    }
  };

  handleInputFocus = ({ target }) => {
    this.setState({
      focused: target.name,
    });
  };

  handleInputChange = ({ target }) => {
    if (target.name === "number") {
      target.value = formatCreditCardNumber(target.value);
    } else if (target.name === "expiry") {
      target.value = formatExpirationDate(target.value);
    } else if (target.name === "cvc") {
      target.value = formatCVC(target.value);
    }
    this.setState({ [target.name]: target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { issuer } = this.state;
    const formData = [...e.target.elements]
      .filter((d) => d.name)
      .reduce((acc, d) => {
        acc[d.name] = d.value;
        return acc;
      }, {});

    this.setState({ formData });
    this.form.reset();
  };
  payViaCard = (card) => {
    const newCardList = this.state.cardList.map((cardItem) => {
      return card.id == cardItem.id
        ? { ...cardItem, selected: true }
        : { ...cardItem, selected: false };
    });
    this.setState({ cardSelected: card, cardList: newCardList }, () => {
      this.closePaymentModal();
    });

    /* this.setState({ isPayClick: cardId, acceptLoadingButton: true });
        this.props.payViaCardAction(
            {
                cardId: cardId,
                bookingToken: this.state.bookingId == "" ?
                    "" : this.state.booking.token,
                rejected_services: this.state.rejected_services,
                card_payment_detail: this.state.card_payment_detail,
                hourly_booked_services: this.state.hourly_booked_services,
                package_booked_services: this.state.package_booked_services
            },
            this.onPaymentDone
        ); */
  };
  onPaymentDone = (success, data) => {

    this.setState({ isPayClick: "" });
    if (success) {
      NotificationManager.success(data.message, "Success");
      this.setState({
        redirectBookingSuccess: this.state.fromBookingDetail ? true : false,
        redirectBookingStatus: this.state.fromBookingDetail ? false : true,
        rejected_services: !this.state.fromBookingDetail
          ? data.data.rejected_services
          : [],
        card_payment_detail: !this.state.fromBookingDetail
          ? data.data.card_payment_detail
          : [],
        hourly_booked_services: !this.state.fromBookingDetail
          ? data.data.hourly_booked_services
          : [],
        package_booked_services: !this.state.fromBookingDetail
          ? data.data.package_booked_services
          : [],
      });
    } else {
      NotificationManager.error(data.message, "Oops!");
    }
  };

  alertDeleteCard = (cardId) => {
    this.setState({ deleteAlert: true, cardSelected: cardId });
  };

  handleYes = () => {
    this.setState({ deleteAlert: false });
    this.deleteCard(this.state.cardSelected);
  };
  handleNo = () => {
    this.setState({ deleteAlert: false });
  };

  deleteCard = (cardId) => {
    this.props.deleteCardAction(
      {
        cardToken: cardId,
      },
      this.onDeleteDone
    );
  };

  onDeleteDone = (success, data) => {
    if (success) {
      NotificationManager.success(data.message, "Success");
    }
  };

  getBookingAmount = () => { };

  showAddFundOption = () => {
    this.setState({ showFundOption: true });
  };

  showWalletPopup = () => {
    this.setState({ showAddWalletOption: true });
  };
  closeWalletPopup = () => {
    this.setState({ showAddWalletOption: false });
  };
  closeAddAmountPopup = () => {
    this.setState({ showAddPopup: false });
  };
  renderAddPopup = () => {
    this.setState({ showAddPopup: true });
  };
  handleChangeBooking = (i) => {
    var month = ("0" + (new Date().getMonth() + 1)).slice(-2);
    var day = ("0" + new Date().getDate()).slice(-2);
    var todayDate = new Date().getFullYear() + "-" + month + "-" + day;
    console.log("today date::::", todayDate);
    if (i == 0) {
      this.getSlots(todayDate);
      this.setState(
        {
          /* haveSlots: true, */
          bookingValue: "today",
          isTodayProcessing: true,
          isTodaySlot: true,
          forFuture: false,
          dateTimeValue: todayDate,
        },
        () => {
          this.setTimeSlot;
        }
      );
    } else {
      if (this.state.isTodayProcessing) {
        console.log("TO khuch nhi hoga if me ");
      } else {
        this.setState({
          openDateTime: true,
          isTodaySlot: false,
          forFuture: true,
        });
      }
    }
  };

  handleChangeServiceType = (i) => {
    if (i == 1) {
      this.setState({
        serviceTypeValue: "recurring",
        service_type_id: i,
        showRecurringType: true,
      });
    } else {
      this.setState({
        serviceTypeValue: "onetime",
        service_type_id: i,
        showRecurringType: false,
        recurring_type_id: 0,
      });
    }
  };
  handleChangeRecurring = (i) => {

    console.log("recurring", this.state.recurring_type_id)

    if (i != this.state.recurring_type_id) {
      if (i == 0) {
        this.setState({ recurring_type_id: i });
      } else {
        this.setState({ recurring_type_id: i });
      }
    }
  };
  handleChangeAtHome = (i) => {
    if (i == 1) {
      this.setState({
        atHomeValue: "no",
        showAdditionalText: true,
        atHomeStatus: false,
      });
    } else {
      this.setState({
        atHomeValue: "yes",
        showAdditionalText: false,
        atHomeStatus: true,
      });
    }
  };

  handleDrop(files) {
    /*  var base64=""
         var file = files[0]
         const reader = new FileReader();
         reader.onload = (event) => {
           console.log(event.target.result);
             base64=event.target.result;
         };
         reader.readAsDataURL(file);
  */
    this.setState({
      files: /* files.map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })
            ), */
        this.state.files.concat(
          files.map((file) =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            })
          )
        ),
    });

    var formData = new FormData();
    formData.append("image", files[0]);
    axios({
      method: "post",
      url: `${SERVER_URL}/booking/upload-image`,
      data: formData,
    }).then((resJson) => {
      if (resJson.data.status == "OK") {
        var newImageNameArray = this.state.imageNameDataSource.concat(
          resJson.data.data
        );
        this.setState(
          {
            imageNameDataSource: newImageNameArray,
          },
          () => {
            console.log(
              "uploaded image names::::",
              this.state.imageNameDataSource
            );
          }
        );

        NotificationManager.success("Success", resJson.data.message);
      } else {
        NotificationManager.error("Oops!", resJson.data.message);
      }
    });
  }

  onImageLoaded = (image, pixelCrop) => {
    this.imageRef = image;
  };
  onCropComplete = async (crop, pixelCrop) => {
    console.log("inside cropComplete:::::::::", this.state.croppedImageUrl);

    if (crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        pixelCrop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl }, () => {
        console.log("inside cropComplete:::::::::", this.state.croppedImageUrl);
      });
    }
  };

  getCroppedImg(image, pixelCrop, fileName) {
    const canvas = document.createElement("canvas");

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      0,
      0,
      pixelCrop.width,
      pixelCrop.height
    );

    return new Promise((resolve, reject) => {
      this.fileUrl = canvas.toDataURL("image/jpeg");
      resolve(this.fileUrl);
    });
  }

  renderInput = () => {
    return (
      <div
        onClick={() =>
          this.state.isTodayProcessing
            ? {}
            : this.setState({
              openDateTime: true,
              isTodaySlot: false,
              forFuture: true,
            })
        }
        style={{
          width: "100%",
          height: 70,
          display: "flex",
          flexDirection: "row",
          paddingLeft: 10,
          backgroundColor:
            this.state.bookingValue == "future"
              ? this.props.colors.SECONDARY.HEX
              : "#ffffff",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: 50,
            height: 50,
            borderRadius: 5,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor:
              this.state.bookingValue == "future" ? "#ffffff" : "#0078ff",
            alignContent: "center",
            display: "flex",
          }}
        >
          <img
            width={30}
            height={30}
            src={
              this.state.bookingValue == "future"
                ? require("../../assets/images/notfuture.png")
                : require("../../assets/images/future.png")
            }
            style={{ alignSelf: "center" }}
          />
        </div>
        <p
          style={{
            alignSelf: "center",
            marginLeft: 10,
            fontWeight: 500,
            color: this.state.bookingValue == "future" ? "#ffffff" : "#000000",
          }}
        >
          Future
        </p>
      </div>
    );
  };

  /* removeImage = (item, index) => {
        console.log("Image file:::", item)
        this.setState({ removingImage: true, removeIndex: index })
        const { files, imageNameDataSource } = this.state;
        var fileName = item.path.split('#').shift().split('?').shift().split('/').pop();
        var newImagearray = files.filter(singleItem => singleItem.path !== item.path)
        const newImageNamearray = imageNameDataSource.filter(singleItem => singleItem.toLowerCase().indexOf(fileName.toLowerCase()) <= -1);
        this.setState({ files: newImagearray, imageNameDataSource: newImageNamearray, removingImage: false, removeIndex: null });
    } */
  removeImage = async (item, index) => {
    this.setState({ removingImage: true, removeIndex: index });
    const { files, imageNameDataSource } = this.state;
    var fileName = item.path
      .split("#")
      .shift()
      .split("?")
      .shift()
      .split("/")
      .pop();

    var newImagearray = files.filter(
      (singleItem) => singleItem.path !== item.path
    );

    const newImageNamearray = imageNameDataSource.splice(index, 1);

    this.setState(
      {
        files: newImagearray,
        imageNameDataSource: newImageNamearray,
        removingImage: false,
        removeIndex: null,
      },
      () =>
        console.log(
          "after removing::",
          this.state.imageDataSource,
          "names:::",
          this.state.imageNameDataSource
        )
    );
  };

  render() {
    var serviceId = "";
    var service_type = "";
    /* console.log("service id::::::::",this.props.location.state.serviceId) */
    if (this.props.settings.constants.serviceAssignment == "user") {
      serviceId = "";
      service_type = "";
    } else {
      serviceId = this.props.location.state.serviceId;
      service_type = this.props.location.state.service_type;
    }

    const { bookingData, itemId, packageItem } = this.state;
    const { formatMessage } = this.props.intl;

    var min = moment().add(0, "days");
    var max = moment().add(3, "month");

    var valid = function (current) {
      return min <= current && max >= current;
    };
    if (this.state.bookingPopup) {
      return (
        <Redirect
          to={{
            pathname: `/service/booking/`,
          }}
        />
      );
    }

    const thumbs = this.state.files.map((file, index) => {
      console.log("Files:::::::", file);
      return (
        <div
          className="col-md-4 mt-2 d-flex"
          style={{ justifyContent: "center", marginTop: 25, marginBottom: 25 }}
          key={index}
        >
          <div>
            <img className="file_img" alt="Crop" style={{ width: "100%" }} src={file.preview} />
          </div>
          <HighlightOff
            style={{ position: "absolute", bottom: -25, color: "red" }}
            onClick={() => {
              this.removeImage(file, index);
            }}
          />
        </div>
      );
    });

    if (this.state.createLoader) {
      return (
        <div>
          <div
            style={{
              backgroundColor: this.props.theme.palette.primary.main,
              height: "80px",
              width: "100%",
            }}
          />
          <div className="creat-booking-page">
            <div className="container">
              <div
                className="dir-alp-con dir-alp-con-1"
                style={{ minHeight: 600 }}
              >
                <h2 className="mb-4">Create Booking</h2>
                <CircularProgress style={{ alignSelf: "center" }} />
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        // <HOCLoader loading={!this.props.data ? true : false}>
        <div>
          <div
            style={{
              backgroundColor: this.props.theme.palette.primary.main,
              height: "80px",
              width: "100%",
            }}
          />
          <div className="creat-booking-page">
            <div className="container">
              <div className="dir-alp-con dir-alp-con-1">
                <GridContainer>
                  <GridItem md={7} xs={12} sm={12}>
                    <div className=" provider-bio">
                      <h2 className="mb-4">Create Booking</h2>
                      <Paper
                        elevation={2}
                        style={{
                          paddingTop: 20,
                          paddingBottom: 20,
                          paddingLeft: 10,
                          paddingRight: 10,
                        }}
                      >
                        <h4 style={{ alignSelf: "center" }}>
                          <b>When do you want the service ?</b>
                        </h4>
                        <div
                          className="md-12 d-flex pt-3 pb-1"
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-around",
                          }}
                        >
                          {!this.state.isTodaySlot ? (
                            <Paper
                              onClick={() => {
                                this.handleChangeBooking(0);
                              }}
                              className="d-flex"
                              style={{
                                alignContent: "center",
                                alignItems: "center",
                                width: "40%",
                                height: 70,
                                flexDirection: "row",
                                paddingLeft: 10,
                              }}
                            >
                              <div
                                style={{
                                  width: 50,
                                  height: 50,
                                  borderRadius: 5,
                                  justifyContent: "center",
                                  alignItems: "center",
                                  backgroundColor: "#EA9D16",
                                  alignContent: "center",
                                  display: "flex",
                                }}
                              >
                                <img
                                  width={25}
                                  height={25}
                                  src={require("../../assets/images/today.png")}
                                  style={{ alignSelf: "center" }}
                                />
                              </div>
                              <p
                                style={{
                                  alignSelf: "center",
                                  fontSize: 16,
                                  fontWeight: "500",
                                  marginLeft: 10,
                                  color: "#000000",
                                }}
                              >
                                Today
                              </p>
                            </Paper>
                          ) : (
                            <Paper
                              onClick={() => {
                                this.handleChangeBooking(0);
                              }}
                              className="d-flex"
                              style={{
                                alignContent: "center",
                                alignItems: "center",
                                flexDirection: "row",
                                backgroundColor: "#EA9D16",
                                width: "40%",
                                height: 70,
                                paddingLeft: 10,
                                position: "sticky",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 0,
                                }}
                              >
                                {" "}
                                <img
                                  style={{
                                    height: 20,
                                    width: 20,
                                    resizeMode: "contain",
                                  }}
                                  src={require("../../assets/images/check.png")}
                                />
                              </div>
                              <div
                                style={{
                                  width: 50,
                                  height: 50,
                                  borderRadius: 5,
                                  justifyContent: "center",
                                  alignItems: "center",
                                  backgroundColor: "#ffffff",
                                  alignContent: "center",
                                  display: "flex",
                                }}
                              >
                                <img
                                  width={25}
                                  height={25}
                                  src={require("../../assets/images/nottoday.png")}
                                  style={{ alignSelf: "center" }}
                                />
                              </div>
                              <p
                                style={{
                                  alignSelf: "center",
                                  fontSize: 16,
                                  fontWeight: "500",
                                  marginLeft: 10,
                                  color: "#ffffff",
                                }}
                              >
                                Today
                              </p>
                            </Paper>
                          )}

                          {/* {!this.state.forFuture ? <Paper onClick={() => {
                                                        this.handleChangeBooking(1)
                                                    }}
                                                        className="d-flex" style={{ alignContent: "center", alignItems: "center", justifyContent: "center", width: "30%", height: 40 }}>
                                                        <p style={{ alignSelf: "center", marginTop: 10 }}>Future</p>
                                                    </Paper> : <Paper onClick={() => {
                                                        this.handleChangeBooking(1)
                                                    }}
                                                        className="d-flex" style={{
                                                            alignContent: "center", alignItems: "center", backgroundColor: this.props.colors.SECONDARY.HEX,
                                                            justifyContent: "center", width: "30%", height: 40
                                                        }}>
                                                            <Datetime
                                                                open={this.state.openDateTime}
                                                                isValidDate={valid}
                                                                timeFormat={false}
                                                                viewDate={moment()}
                                                                color="primary"
                                                                renderInput={this.renderInput}
                                                                value={this.state.dateTimeValue}
                                                                onChange={this.onChangeDate}
                                                            />
                                                            {/* <p style={{ alignSelf: "center", marginTop: 10 }}>Future</p> 
                                                        </Paper>} */}
                          <Paper
                            onClick={() => {
                              this.state.isTodayProcessing
                                ? console.log("Khcuh nhi hoga")
                                : this.handleChangeBooking(1);
                            }}
                            className="d-flex"
                            style={{
                              alignContent: "center",
                              alignItems: "center",
                              backgroundColor:
                                this.state.bookingValue == "future"
                                  ? this.props.colors.SECONDARY.HEX
                                  : "#ffffff",
                              width: "40%",
                              height: 70,
                              color:
                                this.state.bookingValue == "future"
                                  ? "#ffffff"
                                  : "#000000",
                              position: "sticky",
                            }}
                          >
                            {this.state.bookingValue == "future" && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  right: 0,
                                }}
                              >
                                {" "}
                                <img
                                  style={{
                                    height: 20,
                                    width: 20,
                                    resizeMode: "contain",
                                  }}
                                  src={require("../../assets/images/check.png")}
                                />
                              </div>
                            )}
                            {!this.state.forFuture ? (
                              <Datetime
                                open={this.state.openDateTime}
                                disableCloseOnClickOutside={false}
                                isValidDate={valid}
                                timeFormat={false}
                                /* viewDate={moment()} */
                                color="primary"
                                className="custom-date-time"
                                renderInput={this.renderInput}
                                value={this.state.dateTimeValue}
                                onChange={this.onChangeDate}
                                onBlur={() => {
                                  this.setState({
                                    openDateTime: false,
                                  });
                                }}
                              />
                            ) : (
                              <Datetime
                                open={this.state.openDateTime}
                                disableCloseOnClickOutside={false}
                                isValidDate={valid}
                                timeFormat={false}
                                /*viewDate={moment()} */
                                color="primary"
                                className="custom-date-time"
                                renderInput={this.renderInput}
                                value={this.state.dateTimeValue}
                                onChange={this.onChangeDate}
                                onBlur={() => {
                                  this.setState({
                                    openDateTime: false,
                                  });
                                }}
                              />
                            )}
                          </Paper>
                        </div>
                        {/* <RadioGroup aria-label="position" name="position" value={this.state.bookingValue} onChange={this.handleChangeBooking} row>
                                                <FormControlLabel
                                                    value="today"
                                                    control={<Radio color="primary" />}
                                                    label="Today"
                                                    labelPlacement="end"
                                                />
                                                <FormControlLabel
                                                    value="future"
                                                    control={<Radio color="primary" />}
                                                    label="Future"
                                                    labelPlacement="end"
                                                />
                                            </RadioGroup> */}

                        {this.state.bookingValue == "today"
                          ? this.state.todayBookinTimeSlot && (
                            <div className="mb-2 mt-4 z_ind">
                              <h4 className="mb-2">
                                <FormattedMessage
                                  id="time"
                                  defaultMessage="Time"
                                />
                                :
                              </h4>
                              <Button color="primary" varian="disabled">
                                {this.state.todayBookinTimeSlot.label}
                              </Button>
                            </div>
                          )
                          : this.state.bookingValue == "future" && (
                            <div className="row md-12 d-flex mt-4">
                              <div className="col-md-6 z_ind">
                                <h4>
                                  <FormattedMessage
                                    id="datetime.heading"
                                    defaultMessage="Date and Time"
                                  />
                                  :
                                </h4>
                                <p style={{ marginLeft: 13, marginTop: 13 }}>
                                  {/* {this.state.dateTimeValue} */}
                                  {moment(this.state.dateTimeValue).format('MM-DD-YYYY')}
                                </p>
                              </div>
                              {this.state.bookingTimeSlot && (
                                <div className="col-md-6 z_ind">
                                  <h4 className="mb-2">
                                    <FormattedMessage
                                      id="time"
                                      defaultMessage="Time"
                                    />
                                    :
                                  </h4>
                                  <Button color="primary" varian="disabled">
                                    {this.state.bookingTimeSlot.label}
                                  </Button>
                                </div>
                              )}
                            </div>
                          )}
                      </Paper>

                      {(this.state.showServiceType ||
                        this.state.showRecurringType) && (
                          <Paper
                            elevation={2}
                            style={{
                              paddingTop: 20,
                              paddingBottom: 20,
                              paddingLeft: 10,
                              paddingRight: 10,
                              marginTop: 20,
                            }}
                          >
                            {this.state.showServiceType ? (
                              <h4>
                                <b>Choose the service type ?</b>
                              </h4>
                            ) : (
                              <h4>
                                <b>Choose recurrence period?</b>
                              </h4>
                            )}
                            {this.state.showServiceType && (
                              <div
                                className="md-12 d-flex pt-3 pb-1"
                                style={{
                                  flexDirection: "row",
                                  justifyContent: "space-around",
                                }}
                              >
                                <Paper
                                  onClick={() => {
                                    this.handleChangeServiceType(0);
                                  }}
                                  className="d-flex"
                                  style={{
                                    alignContent: "center",
                                    backgroundColor:
                                      this.state.serviceTypeValue == "onetime"
                                        ? this.props.colors.SECONDARY.HEX
                                        : "#ffffff",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "30%",
                                    height: 40,
                                  }}
                                >
                                  <p
                                    style={{
                                      alignSelf: "center",
                                      marginTop: 10,
                                      color:
                                        this.state.serviceTypeValue == "onetime"
                                          ? "#ffffff"
                                          : "#000000",
                                    }}
                                  >
                                    OneTime
                                  </p>
                                </Paper>
                                <Paper
                                  onClick={() => {
                                    this.handleChangeServiceType(1);
                                  }}
                                  className="d-flex"
                                  style={{
                                    alignContent: "center",
                                    alignItems: "center",
                                    backgroundColor:
                                      this.state.serviceTypeValue == "recurring"
                                        ? this.props.colors.SECONDARY.HEX
                                        : "#ffffff",
                                    justifyContent: "center",
                                    width: "30%",
                                    height: 40,
                                  }}
                                >
                                  <p
                                    style={{
                                      alignSelf: "center",
                                      marginTop: 10,
                                      color:
                                        this.state.serviceTypeValue == "recurring"
                                          ? "#ffffff"
                                          : "#000000",
                                    }}
                                  >
                                    Recurring
                                  </p>
                                </Paper>
                              </div>
                            )}

                            {this.state.showRecurringType ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <p style={{ marginTop: 10, marginBottom: 10 }}>
                                  <b>Choose recurring option</b>
                                </p>
                                <div
                                  className="col-md-12"
                                  style={{
                                    width: "100%",
                                    flexDirection: "row",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Paper
                                    onClick={() => {
                                      this.handleChangeRecurring(7);
                                    }}
                                    className="mt-1 d-flex"
                                    style={{
                                      alignContent: "center",
                                      alignItems: "center",
                                      backgroundColor:
                                        this.state.recurring_type_id == 7
                                          ? this.props.colors.SECONDARY.HEX
                                          : "#ffffff",
                                      justifyContent: "center",
                                      width: "25%",
                                      height: 40,
                                      margin: 10,
                                    }}
                                  >
                                    <p
                                      style={{
                                        alignSelf: "center",
                                        marginTop: 10,
                                        color:
                                          this.state.recurring_type_id == 7
                                            ? "#ffffff"
                                            : "#000000",
                                      }}
                                    >
                                      Weekly
                                    </p>
                                  </Paper>
                                  <Paper
                                    onClick={() => {
                                      this.handleChangeRecurring(30);
                                    }}
                                    className="mt-1 d-flex"
                                    style={{
                                      alignContent: "center",
                                      alignItems: "center",
                                      backgroundColor:
                                        this.state.recurring_type_id == 30
                                          ? this.props.colors.SECONDARY.HEX
                                          : "#ffffff",
                                      justifyContent: "center",
                                      width: "25%",
                                      height: 40,
                                      margin: 10,
                                    }}
                                  >
                                    <p
                                      style={{
                                        alignSelf: "center",
                                        marginTop: 10,
                                        color:
                                          this.state.recurring_type_id == 30
                                            ? "#ffffff"
                                            : "#000000",
                                      }}
                                    >
                                      Monthly
                                    </p>
                                  </Paper>
                                  <Paper
                                    onClick={() => {
                                      this.handleChangeRecurring(15);
                                    }}
                                    className="mt-1 d-flex"
                                    style={{
                                      alignContent: "center",
                                      alignItems: "center",
                                      backgroundColor:
                                        this.state.recurring_type_id == 15
                                          ? this.props.colors.SECONDARY.HEX
                                          : "#ffffff",
                                      justifyContent: "center",
                                      width: "25%",
                                      height: 40,
                                      margin: 10,
                                    }}
                                  >
                                    <p
                                      style={{
                                        alignSelf: "center",
                                        marginTop: 10,
                                        color:
                                          this.state.recurring_type_id == 15
                                            ? "#ffffff"
                                            : "#000000",
                                      }}
                                    >
                                      Every 2 Weeks
                                    </p>
                                  </Paper>
                                  <Paper
                                    onClick={() => {
                                      this.handleChangeRecurring(365);
                                    }}
                                    className="mt-1 d-flex"
                                    style={{
                                      alignContent: "center",
                                      alignItems: "center",
                                      backgroundColor:
                                        this.state.recurring_type_id == 365
                                          ? this.props.colors.SECONDARY.HEX
                                          : "#ffffff",
                                      justifyContent: "center",
                                      width: "25%",
                                      height: 40,
                                      margin: 10,
                                    }}
                                  >
                                    <p
                                      style={{
                                        alignSelf: "center",
                                        marginTop: 10,
                                        color:
                                          this.state.recurring_type_id == 365
                                            ? "#ffffff"
                                            : "#000000",
                                      }}
                                    >
                                      Yearly
                                    </p>
                                  </Paper>
                                  <Paper
                                    onClick={() => {
                                      this.handleChangeRecurring(180);
                                    }}
                                    className="mt-1 d-flex"
                                    style={{
                                      alignContent: "center",
                                      alignItems: "center",
                                      backgroundColor:
                                        this.state.recurring_type_id == 180
                                          ? this.props.colors.SECONDARY.HEX
                                          : "#ffffff",
                                      justifyContent: "center",
                                      width: "25%",
                                      height: 40,
                                      margin: 10,
                                    }}
                                  >
                                    <p
                                      style={{
                                        alignSelf: "center",
                                        marginTop: 10,
                                        color:
                                          this.state.recurring_type_id == 180
                                            ? "#ffffff"
                                            : "#000000",
                                      }}
                                    >
                                      Bi-Annual
                                    </p>
                                  </Paper>
                                </div>
                              </div>
                            ) : null}
                          </Paper>
                        )}
                      <Paper
                        elevation={2}
                        style={{
                          paddingTop: 20,
                          paddingBottom: 20,
                          paddingLeft: 10,
                          paddingRight: 10,
                          marginTop: 20,
                        }}
                      >
                        <h4>
                          <b>Will you be home ?</b>
                        </h4>

                        <div
                          className="md-12 d-flex pt-3 pb-1"
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-around",
                          }}
                        >
                          <Paper
                            onClick={() => {
                              this.handleChangeAtHome(0);
                            }}
                            className="d-flex"
                            style={{
                              alignContent: "center",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor:
                                this.state.atHomeValue == "yes"
                                  ? this.props.colors.SECONDARY.HEX
                                  : "#ffffff",
                              width: "30%",
                              height: 40,
                            }}
                          >
                            <p
                              style={{
                                alignSelf: "center",
                                marginTop: 10,
                                color:
                                  this.state.atHomeValue == "yes"
                                    ? "#ffffff"
                                    : "#000000",
                              }}
                            >
                              Yes
                            </p>
                          </Paper>

                          <Paper
                            onClick={() => {
                              this.handleChangeAtHome(1);
                            }}
                            className="d-flex"
                            style={{
                              alignContent: "center",
                              alignItems: "center",
                              backgroundColor:
                                this.state.atHomeValue == "no"
                                  ? this.props.colors.SECONDARY.HEX
                                  : "#ffffff",
                              justifyContent: "center",
                              width: "30%",
                              height: 40,
                            }}
                          >
                            <p
                              style={{
                                alignSelf: "center",
                                marginTop: 10,
                                color:
                                  this.state.atHomeValue == "no"
                                    ? "#ffffff"
                                    : "#000000",
                              }}
                            >
                              No
                            </p>
                          </Paper>
                        </div>
                        <div className="custom-input-text">
                          {this.state.showAdditionalText ? (
                            /*  <div className="col-md-6 mb-2 main-panel cpn-pag-form"> */

                            <form className="form-new mt-2">
                              <TextField
                                id="standard-full-width"
                                placeholder="Enter Lock Box, Key pad, Alarm code and any Special instructions"
                                name="notes"
                                margin={"normal"}
                                fullWidth
                                label="Enter Lock Box, Key pad, Alarm code and any Special instructions "
                                className="login-form-textfield"
                                value={this.state.additionalTextValue}
                                onChange={(event) => {
                                  this.setState({
                                    additionalTextValue: event.target.value,
                                  });
                                }}
                              />
                            </form>
                          ) : null}
                        </div>
                      </Paper>

                      <AddressPanel
                        className="my-4 mt-4"
                        addNewAddress={this.addNewAddress}
                        setBookingAddress={(address) =>
                          this.setAddress(address)
                        }
                      />
                      <PromocodePanel
                        className="my-4"
                        data={this.props.promoData}
                        renderPromoPopup={this.renderPromoPopup}
                        promoCodeApplied={(code, discountedAmount) =>
                          this.appliedPromo(code, discountedAmount)
                        }
                        packageItem={packageItem}
                      />

                      <Paper
                        elevation={2}
                        style={{
                          paddingTop: 20,
                          paddingBottom: 20,
                          paddingLeft: 10,
                          paddingRight: 10,
                          marginTop: 20,
                        }}
                      >
                        <div className="custom-input-text">
                          <form className="form-new">
                            <h4>
                              <b>Additional Notes</b>
                            </h4>
                            <TextField
                              id="standard-full-width"
                              label={formatMessage({
                                id: "booking.addnotes",
                              })}
                              margin={"normal"}
                              name="notes"
                              placeholder={formatMessage({
                                id: "booking.noteplaceholder",
                              })}
                              fullWidth
                              className="login-form-textfield"
                              onChange={(event) => {
                                this.setState({
                                  notes: event.target.value,
                                });
                              }}
                            />
                          </form>
                        </div>
                      </Paper>

                      <Paper
                        elevation={2}
                        style={{
                          paddingTop: 20,
                          paddingBottom: 35,
                          paddingLeft: 10,
                          paddingRight: 10,
                          marginTop: 20,
                        }}
                      >
                        <div className="row update-profile-drop">
                          <div className="col-md-4">
                            <h4 style={{ marginBottom: 20, marginLeft: 10 }}>
                              <b>Add Images</b>
                            </h4>
                            <div
                              className="drop-box"
                              style={{ marginBottom: 20, marginLeft: 10 }}
                            >
                              <Dropzone
                                onDrop={this.handleDrop.bind(this)}
                                accept="image/jpeg,image/jpg,image/png"
                                multiple={true}
                                maxSize={2097152}
                                onDropRejected={handleDropRejected}
                              >
                                {({ getRootProps, getInputProps }) => (
                                  <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <p>
                                      <FormattedMessage
                                        id="customer.dropfiles"
                                        defaultMessage="Drop files here, or click to select files"
                                      />
                                    </p>
                                  </div>
                                )}
                              </Dropzone>
                            </div>
                          </div>

                          {thumbs.length > 0 && <div>{thumbs}</div>}
                        </div>
                      </Paper>

                      <Paper
                        elevation={2}
                        style={{
                          paddingTop: 20,
                          paddingBottom: 20,
                          paddingLeft: 10,
                          paddingRight: 10,
                          marginTop: 20,
                        }}
                      >
                        <div className="mt-4">
                          <div
                            className="md-12"
                            style={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                              display: "flex",
                            }}
                          >
                            <h4>
                              <b>
                                <FormattedMessage
                                  id="booking.paymentoptions"
                                  defaultMessage="Payment Options"
                                />
                              </b>
                            </h4>
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={() =>
                                this.setState({
                                  showPaymentModal: true,
                                })
                              }
                            >
                              EDIT
                            </Button>
                          </div>

                          <div className="row">
                            {console.log("MMMMMMMMMMMMMMMMMOOOOOOOOOOOOOOOOOOOO", this.props.settings.constants.paymentOptions)}
                            {this.props.settings.constants.paymentOptions &&
                              this.props.settings.constants.paymentOptions.map(
                                (option, index) => {
                                  return (
                                    <div
                                      className="creat-book-radio"
                                      key={index}
                                    >


                                      <Radio
                                        className="checked-radio"
                                        checked={
                                          option.value ==
                                          this.state.paymentType
                                        }
                                        onChange={this.handlePaymentOption}
                                        value={`${option.value}`}
                                        name="paymentType"
                                        color="primary"
                                      />

                                      {option.label}
                                    </div>
                                  );
                                }
                              )}
                          </div>
                          {/* {this.state.cardList.length > 0 && <div */}
                          {this.state.cardList.length > 0 &&
                            this.state.paymentType == 2 && (
                              <div
                                style={{
                                  flexDirection: "row",
                                  marginLeft: 0,
                                  justifyContent: "space-between",
                                  minWidth: "65%",
                                  maxWidth: "80%",
                                }}
                              >
                                <Card
                                  preview={true}
                                  number={
                                    "************" +
                                    this.state.cardSelected.last4
                                  }
                                  expiry={
                                    this.state.cardSelected.exp_month
                                      .length == 2
                                      ? this.state.cardSelected.exp_month
                                      : +
                                      this.state.cardSelected.exp_month +
                                      "/" +
                                      this.state.cardSelected.exp_year
                                  }
                                  issuer={this.state.cardSelected.brand}
                                  cvc=""
                                  placeholders={{ name: "" }}
                                />
                              </div>
                            )}
                        </div>
                      </Paper>

                      <Paper>
                        {this.props.settings.constants.serviceAssignment !=
                          "user" &&
                          service_type == "Package" && (
                            <div className="mt-4">
                              <h4 className="mt-2">
                                <b>
                                  <FormattedMessage
                                    id="booking.paymentoptions"
                                    defaultMessage="Payment Options"
                                  />
                                </b>
                              </h4>

                              <div className="row">
                                {this.props.settings.constants.paymentOptions &&
                                  this.props.settings.constants.paymentOptions.map(
                                    (option, index) => {
                                      return (
                                        <div
                                          className="creat-book-radio"
                                          key={index}
                                        >
                                          <Radio
                                            checked={
                                              option.value ==
                                              this.state.paymentType
                                            }
                                            onChange={this.handlePaymentOption}
                                            value={`${option.value}`}
                                            name="paymentType"
                                            color="primary"
                                          />

                                          {option.label}
                                        </div>
                                      );
                                    }
                                  )}
                              </div>
                            </div>
                          )}
                      </Paper>
                    </div>
                  </GridItem>
                  <GridItem md={5} xs={12} sm={12}>
                    <div className="provider-bio">
                      <h2 className="mb-4">Confirm Booking</h2>
                      {console.log("rk", this.state.recurring_type_id)}
                      <ConfirmedData
                        {...this.props}
                        data={bookingData}
                        itemId={itemId}
                        packageItem={packageItem}
                        bookingDate={this.state.dateTimeValue}
                        bookingTime={
                          this.state.isTodaySlot
                            ? this.state.todayBookinTimeSlot
                            : this.state.bookingTimeSlot
                        }
                        selectedAddress={this.state.displayAddress}
                        selectedPromoCode={this.state.promocode}
                        additionalNotes={this.state.notes}
                        finalAmount={this.state.finalAmount}
                        paymentType={this.state.paymentType}


                        cardlastno={this.state.cardList.length > 0 && this.state.cardSelected.last4}

                        showAddFundOption={this.showAddFundOption}
                        selectedServiceId={serviceId}
                        recurring_type_id={this.state.recurring_type_id}
                        showRecurringType={this.state.showRecurringType}
                        is_recurring={
                          this.state.service_type_id == null
                            ? null
                            : this.state.service_type_id
                              ? true
                              : false
                        }
                        atHomeValue={this.state.atHomeStatus}
                        serviceId={this.state.serviceId}
                        service_type={service_type}
                        bookingValue={this.state.forFuture}
                        additionalTextValue={this.state.additionalTextValue}
                        /* imageFiles={this.state.files} */
                        selectedCard={this.state.cardSelected}
                        imageFiles={this.state.imageNameDataSource}
                        serviceData={
                          this.props.location
                            ? this.props.location.state.serviceDataSource
                            : [{}]
                        }
                      />
                    </div>
                  </GridItem>
                </GridContainer>
              </div>
            </div>
          </div>
          {this.state.haveSlots && (
            <BookingTimeSlotPopup
              isVisible={this.state.haveSlots}
              closePopup={this.closeTimeSlotPopup}
              slots={this.state.slots}
              onTimeSlotSelected={this.setTimeSlot}
              isTodaySlot={this.state.isTodaySlot}
            />
          )}

          {this.state.addCoupon && (
            <AddPromoPopup
              isVisible={this.state.addCoupon}
              closePopup={this.closeCouponPopup}
            />
          )}
          {this.state.addAddress && (
            <AddAddressPopup
              settings={this.props.settings}
              userData={this.props.userData}
              isVisible={this.state.addAddress}
              closePopup={this.closeAddressPopup}
            />
          )}
          {this.state.showAddWalletOption && (
            <AddWalletMoney
              open={this.state.showAddWalletOption}
              close={this.closeWalletPopup}
              cardList={this.props.cardList}
              cardLoader={this.props.cardLoader}
            />
          )}

          {this.state.showPaymentModal && (
            <Dialog
              TransitionComponent={Fade}
              disableBackdropClick={false}
              maxWidth={"750"}
              open={this.state.showPaymentModal}
              onClose={this.closePaymentModal}

            >
              <div class="card_view" style={{ backgroundColor: "white", width: 750 }}>
                <div>
                  <div
                  // style={{
                  //   backgroundColor: "#ffffff",
                  //   height: "80px",
                  //   width: "100%",
                  // }}
                  />

                  <div className="creat-booking-page">
                    <Clear className="text-right" style={{ alignSelf: "center", color: "#000000", position: "absolute", right: "0" }} onClick={() => {
                      this.closePaymentModal()
                    }} />
                    <div className="container">
                      <div className="dir-alp-con dir-alp-con-1">
                        <HOCSectionLoader loading={this.state.loaderButton}>
                          <h3>
                            <FormattedMessage
                              id="service.pay"
                              defaultMessage="Pay"
                            />{" "}
                            {this.props.settings.constants.CURRENCY_SYMBOL +
                              (this.state.forFuture
                                ? this.state.serviceDetailData.summary
                                  .total_price
                                : this.state.serviceDetailData.summary
                                  .total_rush_hr_price)}{" "}
                            <FormattedMessage
                              id="service.viacreditcard"
                              defaultMessage="via Credit Card"
                            />
                            :
                          </h3>

                          <SavedCards
                            payViaCard={(cardId) => this.payViaCard(cardId)}
                            isButtonLoading={this.state.isPayClick}
                            clickDelete={this.checkDeleteCard}
                          />

                          <AddNewCard redirectToList={this.redirectList}
                            clickDelete={this.checkDeleteCard}
                          />
                        </HOCSectionLoader>

                        <DeleteAlert
                          open={this.state.deleteAlert}
                          close={this.closeDeleteAlert}
                          handleNo={this.handleNo}
                          handleYes={this.handleYes}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Dialog>
          )}

          {/* {this.state.showAddPopup && (
                    <AddWalletAmountPopup
                        open={this.state.showAddPopup}
                        closeAddAmountPopup={this.closeAddAmountPopup}
                    />
                )} */}
        </div>
        //</HOCLoader>
      );
    }
  }
}
const mapStateToProps = ({ promos, auth, settings }) => {
  return {
    promoData: promos.promoData,
    settings: settings,
    userData: auth.userData,
    colors: settings.colors,
  };
};

const composedComponent = compose(
  withTheme(),
  withStyles(componentsStyle),
  connect(
    mapStateToProps,
    actions
  )
);
export default composedComponent(withCustomTheme(injectIntl(withUser(Create))));


// WEBPACK FOOTER //
// ./src/views/Booking/Create.jsx